
import { defineComponent } from "vue";

import TransportContainerCatalogue from "@/components/catalogues/TransportCatalogue/TransportContainerCatalogue.vue";

export default defineComponent({
  components: { TransportContainerCatalogue },
  props: {},
  methods: {},
  data() {
    return {};
  },
});
